import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TeamEditModal } from './TeamEditModal';
import { PageContent, PageSection } from 'common/styles/page';
import { useGetAllTeamsQuery } from '../api/teamApi';

const TeamCreate: React.FC = () => {
  const navigate = useNavigate();
  const { refetch } = useGetAllTeamsQuery();

  const [searchParams] = useSearchParams();
  const parentTeamParam = searchParams.get('parent_team');
  const parentTeamIdValue = parentTeamParam ? Number(parentTeamParam) : undefined;
  const initialParentTeamId = parentTeamIdValue !== undefined && !Number.isNaN(parentTeamIdValue)
    ? parentTeamIdValue
    : undefined;

  const handleClose = () => {
    const redirect = parentTeamParam ? `/app/teams?parent_team=${parentTeamParam}` : '/app/teams';
    navigate(redirect);
  };

  const handleSuccess = () => {
    refetch();
    const redirect = parentTeamParam ? `/app/teams?parent_team=${parentTeamParam}` : '/app/teams';
    navigate(redirect);
  };

  return (
    <PageContent>
      <PageSection>
        <TeamEditModal
          isOpen={true}
          onClose={handleClose}
          onSuccess={handleSuccess}
          initialParentTeamId={Number.isNaN(initialParentTeamId) ? undefined : initialParentTeamId}
        />
      </PageSection>
    </PageContent>
  );
};

export default TeamCreate;
